import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/dailyScripture";

export const updateDailyScripture = gql`
  mutation updateDailyScripture($input: UpdateDailyScriptureInput!) {
    updateDailyScripture(input: $input) {
      dailyScripture: daily_scripture {
        ...allDailyScripturesFields
      }
    }
  }
  
  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/mutations/updateDailyScripture.js